<template>
  <!-- 會員資訊(有推薦品項和會員tag)(目前沒有用到) -->
  <cus-dialog v-if="name.includes('memberInfo')">
    <!-- memberInfo有重新掃描 memberInfoFirstTime有推薦品項 -->
    <template v-slot:body>
      <div class="member-wrap">
        <div :class="['content', name === 'memberInfo' ? 'pt-30' : '']">
          <p v-if="name === 'memberInfo'" class="scan" @click="submit(1)">重新掃描</p>
          <div v-html="text" class="text-wrap"></div>
        </div>
        <!-- 會員tag -->
        <div class="member-tag-wrap" style="margin-top: 12px">
          <div class="member-tag" :style="`background-color: ${mapValue[cusProps.member_card.tag_01.value]?.color}`">
            <div class="tag-pic">
              <img :src="require(`@/assets/images/${cusProps.member_card.tag_01.value}.png`)" alt="" />
            </div>
            <p>
              {{ mapValue[cusProps.member_card.tag_01.value]?.label + ' ' + cusProps.member_card.tag_01.percent + '%' }}
            </p>
          </div>
          <div class="member-tag" :style="`background-color: ${mapValue[cusProps.member_card.tag_02.value]?.color}`">
            <div class="tag-pic">
              <img :src="require(`@/assets/images/${cusProps.member_card.tag_02.value}.png`)" alt="" />
            </div>
            <p>
              {{ mapValue[cusProps.member_card.tag_02.value]?.label + ' ' + cusProps.member_card.tag_02.percent + '%' }}
            </p>
          </div>
        </div>
        <!-- 推薦品項 -->
        <cus-button
          v-if="name === 'memberInfoFirstTime'"
          :text="`推薦：${
            cusProps.member_card.recommend_product ? cusProps.member_card.recommend_product.item.label : '無'
          }`"
          color="weekGreen"
          :isButton="false"
          :disabled="!cusProps.member_card.recommend_product"
          style="padding: 0; margin-top: 12px"
        ></cus-button>
      </div>
    </template>
    <template v-slot:footer>
      <div v-if="name === 'memberInfo'">
        <cus-button text="關閉" color="blue" @click="close" style="padding: 0"></cus-button>
      </div>
      <div v-else-if="name === 'memberInfoFirstTime'" class="d-flex">
        <cus-button
          text="加入品項"
          color="green"
          :width="50"
          style="padding-left: 0"
          :disabled="!cusProps.member_card.recommend_product"
          @click="submit(cusProps.member_card.recommend_product)"
        ></cus-button>
        <cus-button text="關閉" color="blue" :width="50" @click="close" style="padding-right: 0"></cus-button>
      </div>
    </template>
  </cus-dialog>
  <!-- 旺卡&會員資訊 -->
  <cus-dialog v-else-if="name === 'cardInfo'">
    <template v-slot:body>
      <div class="content pt-30">
        <p class="scan" @click="submit()">重新掃描/更換電話會員</p>
        <div v-if="cusProps.dayungs_card" :class="['text-wrap', cusProps.member_card ? 'text-wrap-multiple' : '']">
          <p>旺卡等級：{{ cusProps.dayungs_card.want_card?.level_description }}</p>
          <p>旺卡卡號：{{ cusProps.dayungs_card.want_card?.card_no }}</p>
          <p>儲值金：{{ cusProps.dayungs_card.want_card?.balance }}</p>
          <p>黃金點數：{{ cusProps.dayungs_card.want_card_point?.balance }}</p>
          <p>本月底到期黃金點數：{{ cusProps.dayungs_card.want_card_point?.will_expired_balance }}</p>
        </div>
        <div v-if="cusProps.member_card" :class="['text-wrap', cusProps.dayungs_card ? 'text-wrap-multiple' : '']">
          <p>會員編號：{{ cusProps.member_card.card_no }}</p>
          <p>姓名：{{ cusProps.member_card.name }}</p>
          <p class="birth-text">{{ cusProps.member_card.birthday }}</p>
        </div>
        <cus-button
          v-if="cusProps.getMemberTicket"
          text="查看電子券"
          color="blue"
          style="min-height: 52px; margin-top: 12px"
          @click="openDialog('ticketList')"
        ></cus-button>
      </div>
    </template>
    <template v-slot:footer>
      <div v-if="cusProps.dayungs_card" class="d-flex">
        <cus-button
          text="退值"
          color="white"
          :width="50"
          :disabled="!cusProps.dayungs_card.want_card?.card_no"
          @click="openDialog('wantCardRefund')"
        ></cus-button>
        <cus-button
          text="加值"
          color="green"
          :width="50"
          :disabled="!cusProps.dayungs_card.want_card?.card_no"
          @click="openDialog('wantCardAdd')"
        ></cus-button>
      </div>
      <cus-button v-else text="關閉" color="blue" @click="close"></cus-button>
    </template>
  </cus-dialog>
  <!-- 訂購人資訊/統編/結帳活動/資訊欄詳情/通知內容 -->
  <cus-dialog v-else>
    <template v-slot:body>
      <div class="content">
        <div v-if="!Array.isArray(text)" v-html="text" class="text-wrap"></div>
        <div v-else>
          <div v-for="(tt, index) in text" :key="index" class="text-wrap text-wrap-multiple" v-html="tt"></div>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div v-if="name === 'buyerTaxId'" class="d-flex">
        <cus-button text="關閉" color="white" :width="50" @click="close"></cus-button>
        <cus-button text="清除資訊" color="red" :width="50" @click="submit"></cus-button>
      </div>
      <div v-else-if="name === 'redeemBonus'" class="d-flex">
        <cus-button
          text="不兌換"
          color="white"
          :width="50"
          @click="submit({ action: false, checkoutInfo: cusProps.checkoutInfo })"
        ></cus-button>
        <cus-button
          text="兌換"
          color="red"
          :width="50"
          @click="submit({ action: true, checkoutInfo: cusProps.checkoutInfo })"
        ></cus-button>
      </div>
      <cus-button v-else text="關閉" color="blue" @click="close"></cus-button>
    </template>
  </cus-dialog>
</template>
<script>
import { inject } from 'vue';
import { mapValue } from '@/utils/define';
export default {
  name: 'information',
  setup() {
    //接受provide值
    const name = inject('name');
    const text = inject('content');
    const close = inject('close');
    const submit = inject('submit');
    const openDialog = inject('openDialog');
    const { cusProps } = inject('cusProps');
    return { name, text, close, submit, openDialog, cusProps, mapValue };
  },
};
</script>
<style lang="scss" scoped>
.content {
  height: 100%;
  position: relative;
  .scan {
    position: absolute;
    white-space: nowrap;
    top: -15px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 2.4rem;
    color: $color-green;
    text-align: center;
    border-bottom: 1.5px solid $color-green;
    font-weight: 500;
    cursor: pointer;
  }
  .text-wrap {
    background-color: $color-gray-3;
    border: 2px solid $color-gray-10;
    border-radius: 4px;
    padding: 16px 18px;
    color: $color-gray-60;
    font-size: 2rem;
    margin: 0 4px;
    height: 100%;
  }
  .text-wrap-multiple {
    height: auto;
    margin: 8px 4px;
  }
}
.member-wrap {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .member-tag-wrap {
    @include flex-between-center;
  }
  .member-tag {
    width: 49%;
    height: 40px;
    padding-left: 35px;
    line-height: 40px;
    font-size: 2rem;
    border-radius: 4px;
    background-color: $color-red;
    color: #fff;
    display: flex;
    position: relative;
    .tag-pic {
      width: 24px;
      height: 24px;
      position: absolute;
      left: 6px;
      top: 50%;
      transform: translateY(-50%);
    }
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
}
.pt-30 {
  padding-top: 30px;
}
.birth-text {
  font-size: 3.5rem;
  color: $color-error;
}
</style>
